import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

import { HttpService, NotificationService } from '../../../../tms-shared';
import { SalesOrderHeader, SalesOrderHeaderNarrative } from '../../../models';
import { TmsWebBaseEditService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class SalesOrderNarrativeService extends TmsWebBaseEditService<SalesOrderHeader, SalesOrderHeaderNarrative> {
  public refreshDetails = new Subject<void>();

  constructor(protected httpService: HttpService, protected notificationService: NotificationService) {
    super('SalesOrderNarrative', $localize`Sales Order Header Narrative`, httpService, notificationService);
  }
}
